
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import SessionService from './common/sessionService'
import Header from './components/Navigation.vue'
const gracePeriod = 60000

export default defineComponent({
  name: 'App',

  data () {
    return {
      warningTimer: null as unknown as number,
      finalTimer: null as unknown as number,
      showExpirationWarning: false,
      timeToSessionExpiration: 0
    }
  },

  computed: {
    ...mapGetters(['sessionExpiration'])
  },

  watch: {
    /**
     * Update the timer whenever the session expiration changes
     */
    sessionExpiration: {
      handler: function (val) {
        if (val) {
          this.startSessionTimer()
        }
      },
      immediate: true
    }
  },

  methods: {
    /**
     * Shows a window to the user with a chance to stay logged in, or logs them out automatically
     * if they do not respond
     */
    beginFinalTimer (sessionExpiration: number) {
      this.showExpirationWarning = true

      this.finalTimer = setInterval(() => {
        this.timeToSessionExpiration = Math.round((sessionExpiration - Date.now()) / 1000)
        if (this.timeToSessionExpiration <= 0) {
          this.clearTimers()
          SessionService.logOut()
        }
      }, 500)
    },

    /**
     * Clears any current timers
     */
    clearTimers () {
      this.showExpirationWarning = false
      clearInterval(this.finalTimer)
      clearTimeout(this.warningTimer)
      this.finalTimer = 0
      this.warningTimer = 0
    },

    /**
     * Logs the user out
     */
    logOut () {
      SessionService.logOut()
    },

    /**
     * Keeps the user logged in
     */
    refreshSession () {
      SessionService.initializeSession()
    },

    /**
     * Begins a timer to show the user a warning before they are automatically logged out
     */
    startSessionTimer () {
      this.clearTimers()

      const timetoExpiration = this.sessionExpiration - Date.now()

      if (timetoExpiration >= gracePeriod) {
        this.warningTimer = setTimeout(() => {
          this.beginFinalTimer(this.sessionExpiration)
        }, timetoExpiration - gracePeriod)
      } else {
        this.beginFinalTimer(this.sessionExpiration)
      }
    }
  },

  components: {
    navHeader: Header
  }
})
